import { Box, Button, Stack, Typography, styled } from '@mui/material';
import { m } from 'framer-motion';
import React from 'react';
import { MotionViewport, varFade } from '../../components/animate';
import { useNavigate } from 'react-router-dom';
import { PATH_PAGE } from '../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled(Stack)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: { xs: 'auto', md: 600 },
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    minHeight: 'min-content',
  },
}));

const ContentSection = styled(Stack)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundImage: 'url(/assets/background/whoAreWe.png)',
  padding: theme.spacing(4),
  zIndex: 2,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(8),
    minHeight: 600,
  },
}));

const ImageSection = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    minHeight: 0,
  },
}));

const DividerStyle = styled(Box)(({ theme }) => ({
  width: 60,
  height: 4,
  backgroundColor: '#fff',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

const ButtonStyle = styled(Button)(({ theme }) => ({
  color: '#fff',
  borderColor: '#fff',
  borderWidth: 2,
  borderStyle: 'solid',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5, 4),
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  '&:hover': {
    borderColor: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}));

// ----------------------------------------------------------------------

export default function HomeWhoAreWe() {
  const navigate = useNavigate();
  return (
    <RootStyle component={MotionViewport}>
      <Stack direction={{ xs: 'column', md: 'row' }} sx={{ position: 'relative' }}>
        <ContentSection component={m.div} variants={varFade().inLeft} justifyContent="center" spacing={3}>
          <Stack spacing={2} width={{ xs: 1, md: 0.5 }}>
            <Typography
              component={m.h2}
              variants={varFade().inUp}
              variant="h2"
              sx={{
                color: '#fff',
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '2.5rem' },
                lineHeight: 1.2,
              }}
            >
              Qui sommes-nous ?
            </Typography>

            <Typography
              component={m.p}
              variants={varFade().inUp}
              sx={{
                color: '#fff',
                fontWeight: 400,
                fontSize: { xs: '1rem', md: '1.125rem' },
                opacity: 0.95,
              }}
            >
              Votre partenaire pour réussir vos projets d'investissement
            </Typography>

            <DividerStyle component={m.div} variants={varFade().inUp} />

            <Typography
              component={m.p}
              variants={varFade().inUp}
              sx={{
                color: '#fff',
                fontWeight: 400,
                fontSize: { xs: '0.9rem', md: '1rem' },
                lineHeight: 1.8,
                opacity: 0.9,
              }}
            >
              LʼAPI-ZF promeut le Togo comme destination dʼinvestissements productifs, facilite lʼimplantation des entreprises
              et accompagne durablement leur	développement. Elle informe, oriente, instruit dossiers de demande agréments
              relevant de son mandat et assure le suivi post-investissement. 
            </Typography>

            <Box component={m.div} variants={varFade().inUp} sx={{ pt: 1 }}>
              <ButtonStyle variant="outlined" size="large" onClick={() => navigate(PATH_PAGE.accueil.presentation)}>
                Decouvrir l'API-ZF
              </ButtonStyle>
            </Box>
          </Stack>
        </ContentSection>

        {/* Section image droite */}
        <ImageSection component={m.div} variants={varFade().inRight} />
      </Stack>
    </RootStyle>
  );
}
